import React, { Component } from "react";
import { connect } from 'react-redux';
import { checkPermission } from "../../utils/permission";
import { DeleteOutlined, DownOutlined, MenuOutlined, ProfileOutlined } from "@ant-design/icons";
import { Dropdown, Modal, Space } from "antd";
import { getListCustomerSchedule, getSpecificCustomerSchedule, removeCustomerSchedule } from '../../redux/actions/CustomerScheduleActions';
import { getSpecificCustomer } from '../../redux/actions/customerActions';
import CustomerMediaProfileScheduleForm from "../media/CustomerMediaProfileScheduleForm";

const { confirm } = Modal;

class DropdownActions extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentItem: null,
            currentData: null,
            isOpenProfileForm: false,
            schedule_id: null
        }
    }

    openUpdateProfile(customer_id, schedule_id) {
        this.props.getSpecificCustomer(customer_id).then(res => {
            this.setState({ isOpenProfileForm: true, currentData: res, schedule_id: schedule_id });
        });
    }

    openAlert(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá lịch hẹn này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.removeCustomerSchedule([id]).then(() => {
                setTimeout(() => {
                    Modal.destroyAll();
                }, 800);
                this.props.reloadData();
            }),
            onCancel() { },
        })
    }

    render() {

        const {
            isOpenProfileForm,
            currentData,
            schedule_id
        } = this.state;

        const renderItems = () => {
            const itemsAction = [];
            const { record } = this.props;

            if (checkPermission('customer', 'update_image_profile')) {
                itemsAction.push(
                    {
                        key: '10',
                        label: (
                            <div onClick={() => this.openUpdateProfile(record.customer_id, record.id)}>Ảnh hồ sơ, hợp đồng</div>
                        ),
                        icon: <ProfileOutlined />
                    }
                )
            }

            if (checkPermission('customer_schedule', 'remove')) {
                itemsAction.push(
                    {
                        key: '9',
                        label: (
                            <div onClick={() => this.openAlert(record.id)}>Xóa lịch hẹn</div>
                        ),
                        icon: <DeleteOutlined />,
                        danger: true
                    }
                )
            }
            Object.keys(itemsAction).sort();
            //console.log(Object.keys(itemsAction).sort());
            return itemsAction;
        }

        const items = renderItems();

        return (
            <>
                <Space size="middle">
                    {items && items.length > 0 ? (
                        <Dropdown trigger="click" menu={{ items }}>
                            <div className='item-action-btn'>
                                <MenuOutlined /> <DownOutlined />
                            </div>
                        </Dropdown>
                    ) : (
                        <MenuOutlined style={{ color: '#dedede' }} />
                    )}
                </Space>

                <CustomerMediaProfileScheduleForm
                    visible={isOpenProfileForm}
                    currentCustomer={currentData}
                    schedule_id={schedule_id}
                    reloadData={() => false}
                    onCancel={() => this.setState({ isOpenProfileForm: false })}
                />
            </>
        );
    }
}

function mapStateToProps(state) {
    return {}
}

function mapDispatchToProps(dispatch) {
    return {
        getListCustomerSchedule: (filter) => dispatch(getListCustomerSchedule(filter)),
        getSpecificCustomerSchedule: (id) => dispatch(getSpecificCustomerSchedule(id)),
        removeCustomerSchedule: (ids) => dispatch(removeCustomerSchedule(ids)),
        getSpecificCustomer: (id) => dispatch(getSpecificCustomer(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DropdownActions);